<template>
  <v-tooltip :open-delay="0" :location="location" :max-width="maxWidth" :width="width" interactive>
    <template #activator="{ props }">
      <v-btn-icon
        :variant="variant"
        density="compact"
        v-bind="mergeProps(props, $attrs)"
        :color="color"
        :size="size"
        :icon="icon"
      />
    </template>
    <div class="p-relative">
      <slot>
        <small>
          {{ hint }}
        </small>
      </slot>
    </div>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent, mergeProps, PropType } from 'vue'
import { Anchor } from 'vuetify/framework'
import { VuetifySizes } from '~/types/vuetify-helpers'
import type { VuetifyColors } from '~/types/vuetify-helpers'

export default defineComponent({
  name: 'InfoHintIcon',
  props: {
    hint: {
      type: String,
      required: false,
      default: '=)',
    },
    location: {
      type: String as PropType<Anchor>,
      default: 'top',
    },
    size: {
      type: [String, Number] as PropType<VuetifySizes>,
      default: 'small',
    },
    maxWidth: {
      type: [String, Number],
      default: 350,
    },
    width: {
      type: [String, Number],
      required: false,
      default: undefined,
    },
    color: {
      type: String as PropType<VuetifyColors>,
      default: undefined,
    },
    variant: {
      type: String as PropType<'flat' | 'text' | 'elevated' | 'tonal' | 'outlined' | 'plain'>,
      default: 'plain',
    },
    icon: {
      type: String as PropType<`mdi-${string}`>,
      default: 'mdi-information-outline',
    },
  },
  setup() {},
  methods: { mergeProps },
})
</script>
